export const SHOW_CONFIRM = 'confirm/SHOW_CONFIRM';
export const SHOW_ALERT = 'confirm/SHOW_ALERT';
export const OK = 'confirm/OK';
export const CANCEL = 'confirm/CANCEL';
